<mat-form-field class="multiselect-autocomplete" appearance="outline" (focus)="focusAutocompleteInput()">
	<mat-label>{{ fieldLabel }}</mat-label>
	<mat-chip-list #chipList aria-label="selection">
		<mat-chip *ngFor="let item of selectedData" [selectable]="selectable" [removable]="removable" (removed)="remove(item)">
			{{ getLabel(item) }}
			<mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
		</mat-chip>
		<input #autocompleteInput [placeholder]="'Search ' + placeholder + ' ...'" [formControl]="autocompleteCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" matChipInputAddOnBlur="false" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" (blur)="addOnBlur($event)" />
	</mat-chip-list>
	<mat-autocomplete
		#auto="matAutocomplete"
		(optionSelected)="selected($event)"
	>
		<mat-option
			[ngClass]="{ selected: isSelected(item) }"
			*ngFor="let item of filteredData"
			[value]="getValue(item)"
			[disabled]="isSelected(item)"
		>
			{{ getLabel(item) }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
